import { useState, useEffect } from 'react'

interface TypingEffectProps {
  words: string[]
  prefix?: string
  suffix?: string
  className?: string
}

export const TypingEffect = ({
  words,
  prefix = '',
  suffix = '',
  className = ''
}: TypingEffectProps) => {
  const [text, setText] = useState('')
  const [wordIndex, setWordIndex] = useState(0)
  const [isDeleting, setIsDeleting] = useState(false)
  const [cursorVisible, setCursorVisible] = useState(true)

  useEffect(() => {
    const typingDelay = 150 // Скорость печати
    const deletingDelay = 100 // Скорость стирания
    const wordDelay = 3000 // Задержка перед сменой слова

    const type = () => {
      const currentWord = words[wordIndex]

      if (isDeleting) {
        // Стираем текст
        setText(currentWord.substring(0, text.length - 1))

        if (text.length === 0) {
          setIsDeleting(false)
          setWordIndex((prev) => (prev + 1) % words.length)
        }
      } else {
        // Печатаем текст
        setText(currentWord.substring(0, text.length + 1))

        if (text.length === currentWord.length) {
          // Ждем перед началом стирания
          setTimeout(() => {
            setIsDeleting(true)
          }, wordDelay)
          return
        }
      }
    }

    const timer = setTimeout(type, isDeleting ? deletingDelay : typingDelay)
    return () => clearTimeout(timer)
  }, [text, isDeleting, wordIndex, words])

  // Анимация мигающего курсора
  useEffect(() => {
    const cursorTimer = setInterval(() => {
      setCursorVisible((prev) => !prev)
    }, 530)
    return () => clearInterval(cursorTimer)
  }, [])

  return (
    <span className={className}>
      {prefix}
      <span className="relative">
        {text}
        <span
          className={`absolute -right-[2px] top-0 w-[2px] h-full bg-black dark:bg-white transition-opacity duration-100 ${
            cursorVisible ? 'opacity-100' : 'opacity-0'
          }`}
        />
      </span>
      {suffix}
    </span>
  )
}
